<template>
    <div class="auth__show">
        <div class="auth__show_main">
            <div class="container">
                <template v-if="notificationContent">
                    <div class="auth__show_main_note">
                        <div class="columns is-centered">
                            <div class="column is-8-desktop">
                                <component-note>{{ notificationContent }}</component-note>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="auth__show_main_boxes">
                    <div class="columns is-centered">
                        <div class="column is-8-desktop">
                            <div class="columns is-variable">
                                <div class="column is-6-desktop">
                                    <component-box
                                        :title="$t('auth.show.buttons.LogIn')"
                                        :content="$t('auth.show.title.contentAccount')"
                                        :button-text="$t('auth.show.buttons.LogIn')"
                                        :to="{ name: 'auth-login', query: $route.query }"
                                    />
                                </div>
                                <div class="column is-6-desktop">
                                    <component-box
                                        :disabled="!allowSelfSignUp"
                                        :title="$t('auth.show.buttons.SignUp')"
                                        :content="$t('auth.show.title.contentNewUser')"
                                        :button-text="$t('auth.show.buttons.SignUp')"
                                        :to="{ name: 'auth-signup', query: $route.query }"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentBox from '@/components/default/shared/ComponentBox'
import ComponentNote from '@/components/default/shared/ComponentNote'

export default {
  name: 'auth-show',
  data () {
    return {
      notificationContent: ''
    }
  },
  components: { ComponentNote, ComponentBox },
  computed: {
    allowSelfSignUp () {
      return this.$route.query.invitation && this.$route.query.userId
    },
    isUserLoggedIn () {
      return this.$store.getters.getAuthUserFirstStageTokenData
    },
    loggedInUserId () {
      return this.$store.getters.getAuthUserFirstStageTokenDataID || this.$store.getters.getAuthUserSecondStageTokenDataUserId
    }
  },
  methods: {
    checkIsInvitation () {
      if (this.$store.getters.getAuthUserSignUpInvitation) {
        this.notificationContent = this.$t('auth.show.notificationContentJs')
      }
    }
  },
  mounted () {
    this.checkIsInvitation()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/auth/show/authshow";
</style>
